import React from 'react';
import type { MatchDetail } from '@iziping/common';
import { MatchStatus } from '@iziping/common';
import './HeatBracketDisplay.css';
import { formatPlayersForBracket } from '@iziping/common';

interface MatchBracketProps {
    match: MatchDetail;
}

const MatchBracket: React.FC<MatchBracketProps> = ({ match }) => {
    const p1 = match.opponents.length > 0 ? match.opponents[0] : null;
    const p2 = match.opponents.length > 1 ? match.opponents[1] : null;

    const p1Name = p1 ? formatPlayersForBracket(p1.heatRegistration) : '';
    const p2Name = p2 ? formatPlayersForBracket(p2.heatRegistration) : '';

    const statusClass =
        match.status === MatchStatus.RUNNING
            ? 'match-running'
            : match.status === MatchStatus.FINISHED
              ? 'match-finished'
              : 'match-pending';

    return (
        <>
            <li className="spacer" />
            <li className={`match-card ${statusClass}`}>
                <div className="match-card-box">
                    <div className={`match-player${p1?.qualified ? ' match-winner' : ''}${!p1Name ? ' empty' : ''}`}>
                        <span className="match-player-name">{p1Name || '—'}</span>
                    </div>
                    <div className={`match-player${p2?.qualified ? ' match-winner' : ''}${!p2Name ? ' empty' : ''}`}>
                        <span className="match-player-name">{p2Name || '—'}</span>
                    </div>
                </div>
            </li>
        </>
    );
};

export default MatchBracket;
